import React, { Dispatch, SetStateAction } from 'react';
import {ContainerSwitch, CheckBox, CheckBoxLabel} from './styles';
import Theme from '../../../styles/models/theme';

interface SwitchProps {
    theme: Theme,
    enabled: boolean,
    setEnabled: Dispatch<SetStateAction<boolean>>,
}

const Switch: React.FC<SwitchProps> = ({ theme, enabled, setEnabled }) => {
  return (
    <ContainerSwitch >
      <CheckBox id="checkbox" type="checkbox" theme={theme}  onClick={()=>setEnabled(!enabled)} />
      <CheckBoxLabel isActive={enabled} htmlFor="checkbox" theme={theme} />
    </ContainerSwitch>
  );
};

export default Switch;
